/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="56"
    height="48"
    viewBox="0 0 56 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.0002 28.4444C32.9094 28.4444 36.8891 24.4647 36.8891 19.5555C36.8891 14.6463 32.9094 10.6666 28.0002 10.6666C23.091 10.6666 19.1113 14.6463 19.1113 19.5555C19.1113 24.4647 23.091 28.4444 28.0002 28.4444Z"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1113 19.5555H36.8891"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.9999 10.6666C30.2233 13.1007 31.4868 16.2595 31.5554 19.5555C31.4868 22.8515 30.2233 26.0103 27.9999 28.4444C25.7765 26.0103 24.513 22.8515 24.4443 19.5555C24.513 16.2595 25.7765 13.1007 27.9999 10.6666V10.6666Z"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="1.3335"
      y="1.77783"
      width="53.3333"
      height="35.5556"
      rx="3.55556"
      strokeWidth="1.77778"
    />
    <path d="M12.7617 46.2222L43.2379 46.2222" strokeWidth="1.77778" strokeLinecap="round" />
    <path d="M22.0742 37.3334L22.0742 46.2223" strokeWidth="1.77778" strokeLinecap="round" />
    <path d="M33.9258 37.3334L33.9258 46.2223" strokeWidth="1.77778" strokeLinecap="round" />
  </svg>
);
